import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import { BulkActionsResult } from "components/BulkActions/types";
import SpacePath from "components/SpacePath";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography from "ds/components/Typography";
import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

type AiIntegrationsBulkActionsResultItemProps = {
  integration: AiIntegrationView;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const AiIntegrationsBulkActionsResultItem = ({
  integration,
  resultsMetadata,
  status,
  stopExecution,
}: AiIntegrationsBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={integration.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <Box direction="column" gap="medium" grow="1" zeroMinWidth fullWidth>
          <TextEllipsis tooltip={integration.name} tooltipWidthMode="maxWidthSm">
            {(props) => (
              <Typography {...props} tag="p" variant="p-body3">
                {integration.name}
              </Typography>
            )}
          </TextEllipsis>

          <Box align="center" gap="medium" zeroMinWidth fullWidth>
            <Typography tag="span" variant="p-body4" color="secondary">
              {integration.provider}
            </Typography>

            {integration.space && (
              <Box zeroMinWidth grow="1">
                <SpacePath spaceId={integration.space.id} fallbackName={integration.space.name} />
              </Box>
            )}
          </Box>
        </Box>

        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(integration.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(integration.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default AiIntegrationsBulkActionsResultItem;
